module.exports = __webpack_public_path__ + "static/media/search-listing-icon-active.eb4c75af.svg";